import React, { ChangeEvent, HTMLProps, useCallback } from 'react';

type TextInputProps = {
  label: string;
  id?: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  onValueChange?: (v: string) => void;
} & HTMLProps<HTMLInputElement>;

const TextInput: React.FC<TextInputProps> = ({
  label,
  value,
  id,
  placeholder,
  required,
  onValueChange,
  ...props
}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const {
        target: { value },
      } = event;
      if (value !== null && onValueChange) onValueChange(value);
    },
    [onValueChange]
  );

  return (
    <div className="my-6">
      <label className="mb-1 block text-sm text-gray-700">
        {label}
        {required ? ' *' : ''}
      </label>
      <input
        className="focus:shadow-outline w-full appearance-none rounded border py-2 px-3 leading-tight text-gray-700 shadow focus:outline-none"
        id={id}
        type="text"
        required={required}
        value={value}
        onChange={handleChange}
        placeholder={placeholder || label}
        {...props}
      />
    </div>
  );
};

export default TextInput;
